// extracted by mini-css-extract-plugin
export var quantityInput = "_g0-0";